import styled, { css } from "styled-components";


export const HubStatsItems = styled.div`
	margin-top: 40px;
	width: 320px;
	padding: 0 10px;
`;

export const HubStatsWrapper = styled.div<{ bg?: string }>`
	box-shadow: 0 20px 20px 0 rgba(0,0,0,0.5);
	background-color: ${ props => props.bg ? props.bg : '#1C1C1C' };
	border-radius: 8px;
	margin-bottom: 20px;
	color: ${ props => props.bg ? '#362E2C' : '#fff' };
	padding: 20px;
	font-family: Barlow, sans-serif;
	font-size: 14px;
	line-height: 17px;
`;

export const HubStatsTitle = styled.div`
	width: 100px;
	font-weight: 700;
	font-size: 16px;
	line-height: 20px;
	margin-bottom: 10px;
`;

export const HubStatsBigTitle = styled.div`
	font-weight: 700;
	font-size: 16px;
	line-height: 20px;
`;

export const HubStatsLegendWrapper = styled.div`

`;

export const HubStatsLegendItem = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 10px;
	
	&:last-child {
		margin-bottom: 0;
	}
`;

interface ILegendIcon {
	color: string;
	bordered?: boolean;
}

export const HubStatsLegendIcon = styled.div<ILegendIcon>`
	width: 12px;
	height: 12px;
	border-radius: 50%;
	flex-shrink: 0;
	margin-right: 7px;
	
	${(props) => props.bordered ? css`
		border: 2px solid ${props.color};
	` : css`
		background-color: ${props.color};
	`};
`;

export const HubStatsLegendTitle = styled.div`
	flex-grow: 1;
`;

export const HubStatsLegendPercents = styled.div`
	text-align: right;
	flex-shrink: 0;
	margin-left: 7px;
`;

export const HubStatsCount = styled.div`
	font-weight: 900;
	font-size: 60px;
	line-height: 70px;
`;

export const GraphWrapper = styled.div`
	margin-top: 30px;
	margin-bottom: 30px;
`;

export const GraphTitleValue = styled.div`
	font-size: 12px;
	line-height: 14px;
	font-weight: 500;
	padding-bottom: 10px;
	border-bottom: 1px solid #362E2C;
	margin-bottom: 30px;
`;
